import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { OtaFile } from "@dashboard/rollouts/types";
import { Box, Theme, Typography } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
    card: {
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.emteria.background.paper,
        maxHeight: 180,
        overflowY: "auto",
    },
    change: {
        whiteSpace: "pre-line",
        "&:not(:last-child)": {
            marginBottom: theme.spacing(1),
        },
    },
}));

type Props = {
    releaseNotes: NonNullable<OtaFile["changes"]>;
};

export const ReleaseNotesCard = ({ releaseNotes }: Props) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["sidepanels", "modals"]);

    const allChanges = releaseNotes.flatMap((entry) => entry.changes).filter((change) => change.trim() !== "");

    if (allChanges.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                {t("modals:changesDialog.noChanges")}
            </Typography>
        );
    }

    return (
        <Box className={classes.card}>
            {allChanges.map((change, index) => (
                <Typography key={index} variant="body2" className={classes.change}>
                    {change}
                </Typography>
            ))}
        </Box>
    );
};
